<template>
    <div class="related-insight" :class="{'related-insight__is-loading': loading}" v-observe-visibility="{callback: visibilityChanged, once: true, intersection: { threshold: 0.3 }, throttle: 300}">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="!loading" v-html="data"/>
        <div class="related-insight--loading" v-else>
            <spinning-loader/>
        </div>
    </div>
</template>

<script>
    import { reinitVueComponents } from '../../base/index';
    import axios from '../../../util/service';
    import SpinningLoader from '../../components/loaders/spinning-loader/spinning-loader';

    export default {
        components: { SpinningLoader },
        props: {
            url: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                data: null,
                loading: true,
            };
        },
        methods: {
            visibilityChanged(isVisible) {
                if (isVisible) {
                    this.fetchUrl();
                }
            },
            fetchUrl() {
                this.loading = true;
                const onSuccess = ({ data }) => {
                    this.loading = false;
                    this.data = data;

                    setTimeout(() => {
                        reinitVueComponents(this.$el);
                    }, 100);
                };
                const onError = (error) => {
                    this.loading = false;
                    this.data = error;
                };

                return axios.get(this.url)
                    .then(onSuccess)
                    .catch(onError);
            },
        },
    };
</script>
